import { IAppState } from 'models/store.model'

import { getPurchaseCommonEventParams } from 'modules/payment/helpers/getPurchaseCommonEventParams'

export const getPurchaseSuccessEventParams = (state: IAppState) => {
  const {
    email,
    productId,
    price,
    trialPrice,
    uuid,
    currency,
    periodName,
    periodQuantity,
    screenName,
    stripeAccountName,
    stripeAccountId,
    isPersonalDataAllowed,
    selectedSubscription,
  } = getPurchaseCommonEventParams(state)

  return {
    email,
    productId,
    price,
    trialPrice,
    uuid,
    currency,
    periodName,
    periodQuantity,
    screenName,
    stripeAccountName,
    stripeAccountId,
    isPersonalDataAllowed,
    selectedSubscription,
  }
}
